import { render, staticRenderFns } from "./SixthBlockСoaches.vue?vue&type=template&id=0b5c893d"
import script from "./SixthBlockСoaches.vue?vue&type=script&lang=js"
export * from "./SixthBlockСoaches.vue?vue&type=script&lang=js"
import style0 from "./SixthBlockСoaches.vue?vue&type=style&index=0&id=0b5c893d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports